<div class="central-staff-status-view">
  <!-- <h4>Central {{staffColumnText}} Status View</h4> -->
  <div class="cc-action-panel row">
    <div class="central-view-filters row">
      <div class="col-md-6">
        <!-- <app-lobby-central-views-location-selector></app-lobby-central-views-location-selector> -->
        <app-location-multi-selector  [isLobby]="true" labelText="{{'_General_Location_Text_' | translate }}" selectedLocationName="{{'_General_No_Branches_Text_' | translate }}"
          [selectorDisabled]="selectorDisable" (onLocationsData)="handleDefaultSelection($event)"
          (onChange)="handleLocationData($event)" [checkedKeys]="checkedKeys" [dispatchStateEvent]="false"
          [hideBranchLess]="true" [isIncludeFloatLocation]="false"></app-location-multi-selector>
      </div>
      <div class="col-md-3">
        <label>{{'_General_Assist_Type_Text_' | translate }}</label>
        <select id="assist-type" (change)="onAssistTypeChange()" [(ngModel)]="selectedAssistType"
          class="cc-select-dropdown form-control">
          <option *ngFor="let assisttype of assistTypes" [ngValue]="assisttype.id">
            {{ assisttype.name | translate }}
          </option>
        </select>
        <!--          {{assistTypes[2]|json}}-->
      </div>
    </div>

    <div class="cc-search">
      <input class="form-control" id="searchInput" (keydown.enter)="searchKeyWordChange()" [(ngModel)]="searchText" placeholder="{{'_General_Search_Text_' | translate }}" />
      <button *ngIf="searchText" (click)="clearSearchKeyWordChange()" [ngClass]="{ 'show-btn': true }"
        class="cc-close-btn">
        <span class="fas fa-times"></span>
      </button>
      <button (click)="searchKeyWordChange()" class="cc-search-btn">
        <span class="fas fa-search"></span>
      </button>
    </div>
  </div>

  <div class="grid-view central-views-grid-wrapper">
    <kendo-grid id="centralStaffGrid" [data]="{
        data: (GridData$ | async)!.data,
        total: (GridData$ | async)!.totalRowCount
      }" [pageSize]="(GridData$ | async)!.pageSize" [skip]="
        (GridData$ | async)!.pageSize *
        ((GridData$ | async)!.currentPageNumber - 1)
      " [pageable]="true" [sortable]="{ allowUnsort: false, mode: 'single' }" [sort]="sort" [scrollable]="'scrollable'"
      (pageChange)="
        getLobbyCentralStaffStatusViewGridDataPageChangeEvent($event)
      " (sortChange)="sortChange($event)" (edit)="infoClickedHandler($event)" (cancel)="productClickedHandler($event)">
      <kendo-grid-messages pagerFirstPage="{{'_Go_To_First_Page_Text_' | translate}}" pagerLastPage="{{'_Go_To_Last_Page_Text_' | translate}}" pagerNextPage="{{'_Go_To_Next_Page_Text_' | translate}}" pagerPreviousPage="{{'_Go_To_Previous_Page_Text_' | translate}}" pagerPage="{{'_Page_Grid_Text_' | translate}}" noRecords="{{'_NoRecords_Grid_Text_' | translate}}" pagerItems="{{'_General_Kendo_Grid_Pageable_Items_Text_' | translate}}" pagerOf="{{'_General_Kendo_Grid_Pageable_Of_Text_' | translate}}"></kendo-grid-messages>
      <kendo-grid-column field="assistType" title="{{'_General_Type_Text_' | translate }}" [width]="70" [sortable]="false"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.isProvideImpersonateAssist && enableUserImpersonationForTenant" 
          title="{{'_General_Assisting_As_Text_' | translate}}: {{dataItem.impersonateAssistStaffNames}}">          
          <img class="h-12" src="assets/images/icon/impersonate-assist.svg" alt="">            
        </span>
          <button *ngIf="dataItem.assistTypeId == 2" class="cc-icon-btn info cursor" title="{{'_General_Instant_Assist_Text_' | translate}}">
            <span class="fas fa-bolt"></span>
          </button>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="locationName" title="{{'_General_Location_Text_' | translate }}" [width]="200" [headerStyle]="{ 'font-weight': 'bold'}"
        [sortable]="true">
      </kendo-grid-column>
      <kendo-grid-column field="staffName" title="{{staffColumnText === 'Staff' ? ('_General_Staff_Text_' | translate) : staffColumnText}}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
      </kendo-grid-column>
      <kendo-grid-column field="status" title="{{'_General_Status_Time_Text_' | translate }}" [width]="220" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <p>
            {{
            (dataItem
            | StaffStatusPipe) | translate
            }} {{
            dataItem.statusChangeLocalTime
            | date:'h:mm a'
            }} ({{
            dataItem.timeZone
            }})
          </p>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="currentAssisting" title="{{'_General_Currently_Assisting_Sub_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{dataItem.currentAssisting}}<span
            *ngIf="dataItem.locationId!=dataItem.currentAssistingLocationId">-{{dataItem.currentAssistingLocationName}}</span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="serviceRequested" title="{{'_General_Request(s)_Text_' | translate }}" [headerStyle]="{ 'font-weight': 'bold'}"
        [sortable]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          <button *ngIf="dataItem.serviceRequested.length > 1" class="cc-icon-btn"
            (click)="productClickedHandler(dataItem)">
            <span class="fas fa-plus"></span>
          </button>
          {{ dataItem.serviceRequested[0] }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="currentAssistTime" title="{{'_General_Current_Assist_Time_Text_' | translate }}" [sortable]="true"
        [headerStyle]="{ 'font-weight': 'bold'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <app-app-timer [thresholdTime]="interactionThreshold" *ngIf="dataItem.statusId === 2" [autoStart]="true"
            [startTime]="dataItem.currentAssistTime" format="hms"></app-app-timer>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="{{'_General_Button_Action_Text_' | translate }}" [width]="100"
        [headerStyle]="{'font-weight' : 'bold', 'text-align':'center', 'justify-content': 'center'}">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="cell-items-center">
            <div class="d-flex justify-content-center align-items-center">
                <button class="cc-icon-btn centered" *ngIf="enableUserImpersonation && enableUserImpersonationForTenant && dataItem.statusId == 2 && dataItem.impersonateById==loggedInUserId"
                  (click)="OpenWrapup(dataItem)" title="{{'_General_WrapUp_Text_' | translate}}">
                  <img class="imp-wrapup-icon" src="assets/images/icon/wrap-up.svg" alt="">
                </button>
                <button class="cc-icon-btn" *ngIf="dataItem.statusId == 2" kendoGridEditCommand>
                  <app-app-timer-button [thresholdTime]="interactionThreshold" [startTime]="dataItem.currentAssistTime">
                  </app-app-timer-button>
                </button>
                <button *ngIf="showForceSignOutIcon(dataItem) && userPermissionList?.includes(48)" class="cc-icon-btn"
                  (click)="showForceSignOutPopUp(dataItem, forceSignOutPopup)" [title]="showSignOutTitle(dataItem)">
                  <span class="fas fa-sign-out-alt"></span>
                </button>
            </div>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>

<kendo-dialog id="interactionDialogModel" class="interaction-popup" title="{{'_General_Interaction_Details_Text_' | translate }}{{
    lastInteractionData.assistedBy.firstName +
      ' ' +
      lastInteractionData.assistedBy.lastName
  }}" *ngIf="opened" (close)="closeInteractionDialog()" [width]="700">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="time-summary">
    <div class="time-summary-tile">
      <span class="time-summary-tile-title">{{'_General_Added_Time_Text_' | translate }}</span><br />
      <span class="time-summary-tile-time">{{
        interactionData.addedLocalTime | date: "h:mm:ss a"
        }}</span>
    </div>

    <div class="time-summary-tile">
      <span class="time-summary-tile-title">{{'_General_Assist_Start_Time_Text_' | translate }}</span><br />
      <span class="time-summary-tile-time">{{
        interactionData.assistingStartTime | date: "h:mm:ss a"
        }}</span>
    </div>

    <div class="time-summary-tile">
      <span class="time-summary-tile-title" [ngClass]="{'time-exceeded': isTimeExceeded == true}">{{'_General_Current_Assist_Time_Text_' | translate }}</span><br />
      <app-app-timer [thresholdTime]="interactionThreshold" [autoStart]="true" (onTimeExceeded)="onTimeExceededHandler($event)" [addTimerColor]="false"
        [startTime]="interactionData.assistingLocalTime" format="hms"></app-app-timer>
    </div>
  </div>

  <div class="interaction-info">
    <div class="row">
      <div class="col-md-5 label">{{'_General_Visitor Name_Text_' | translate }}</div>
      <div class="col-md-7">
        {{ interactionData.firstName + " " + interactionData.lastName }}
      </div>
    </div>

    <div class="row" *ngIf="enableAccountNumber">
      <div class="col-md-5 label">{{'_General_Visitor_Text_' | translate: { value0: ('_Account_Number_Field_Text_' | translate) } }}</div>
      <div class="col-md-7">{{interactionData.accountNumber}}</div>
    </div>

    <div class="row" *ngIf="enableDateOfBirth">
      <div class="col-md-5 label">{{'_General_DOB_Text_' | translate }}</div>
      <div class="col-md-7">{{interactionData.dateOfBirth | date: 'MM-dd-yyyy'}}</div>
    </div>

    <div class="row">
      <div class="col-md-5 label">{{'_General_Request(s)_Text_' | translate }}</div>
      <div class="col-md-7">
        <ul class="request-list">
          <li *ngFor="
              let service of interactionData.requestedServices;
              let index = index
            ">
            {{ service.name }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5 label">{{'_General_Services_Provided_Text_' | translate }}</div>
      <div class="col-md-7">
        <ul class="service-list" *ngFor="let serviceProvided of interactionData.lobbyInteractions; last as isLast">
          <ng-container *ngIf="isLast">
            <li *ngFor="let providedService of serviceProvided.lobbyServiceProvided;let index = index">
              {{providedService.serviceName}}
            </li>
          </ng-container>
        </ul>
      </div>
    </div>

    <div class="row" *ngIf="enableCustomField">
      <div class="col-md-5 label">{{'_Custom_Field_Text_' | translate }}</div>
      <div class="col-md-7">
        <ul>
          <li *ngFor="
              let field of interactionData.customFieldValues;
              let index = index
            ">
            {{ field.customFieldValue }}
          </li>
        </ul>
      </div>
    </div>

    <div class="row">
      <div class="col-md-5 label">{{'_General_Notes_Text_' | translate }}</div>
      <div class="col-md-7">{{ interactionData.notes }}</div>
    </div>
  </div>

  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-primary" (click)="closeInteractionDialog()" primary="true">
      {{'_General_Button_Close_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog id="serviceDialogModel" class="requests-list-popup" title="" *ngIf="opened1"
  (close)="closeProductServiceDialog()" [minWidth]="250" [width]="600">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <kendo-dialog-titlebar>
    <div class="d-flex">
      <span class="request-list-name">
        {{
        productAndServiceData.firstName + " " + productAndServiceData.lastName
        }}
      </span>
      <span> {{'_General_Requests_Sub_Text_' | translate }} </span>
    </div>
  </kendo-dialog-titlebar>
  <div class="psPanel">
    <div class="ps-list">
      <ul>
        <li *ngFor="
            let field of productAndServiceData.requestedServices;
            let index = index
          ">
          {{ field.name }}
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button kendoButton class="btn btn-primary" kendoButton (click)="closeProductServiceDialog()" primary="true">
      {{'_General_Button_Close_Text_' | translate }}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
<app-modalpopup header="{{'_Lobby_Staff_Confirm_Force_Sign_Out_Text_' | translate }}" [isInfo]="false" actionNoLabel="{{'_General_Action_Label_No_Text_' | translate }}" actionYesLabel="{{'_General_Action_Label_Yes_Text_' | translate }}"
  id="forceSignOutDialog" #forceSignOutPopup [message]="forceSignOutMessage"
  (submitted)="userForceSignOut(forceSignOutPopup)">
</app-modalpopup>
